<mat-form-field *ngIf='control' appearance='outline'>

  <mat-label>Sesso</mat-label>

  <mat-select [formControl]='control'>
    <mat-option *ngFor='let gender of values' [value]='gender'>
      {{getLabel(gender)}}
    </mat-option>
    <mat-option [value]='null'>Vedi tutto</mat-option>
  </mat-select>

</mat-form-field>
